import React from 'react';

export default function CreateFooter({
  disabled,
  onCreate,
  label = 'Создать бизнес',
  leading = null,
}) {
  return (
    <footer className="shop-create-footer">
      <div className={`shop-create-footerActions${leading ? ' shop-create-footerActions--split' : ''}`}>
        {leading}
        <button
          className="shop-create-buttonPrimary"
          type="button"
          disabled={disabled}
          onClick={onCreate}
        >
          {label}
        </button>
      </div>
    </footer>
  );
}
